// extracted by mini-css-extract-plugin
module.exports = {"checkboxInput":"CheckboxChange_checkboxInput__2Vzd1","checkboxEdit":"CheckboxChange_checkboxEdit__25al2","checkboxOk":"CheckboxChange_checkboxOk__1AUdi"};